<template>
  <div class="root-container">
    <div class="container">
      <div class="quiz-header">
        <div class="text-num">結果発表</div>
        <div class="logo"><img src="public/images/logo.png" alt="" /></div>
      </div>
      <div class="illustration" ref="animationContainer"></div>
      <div class="result-box">
        <div class="score">
          {{ totalCount }}問
          <span class="score-num">{{ correctCount }}</span> 問
          <span class="score-correctness">正解</span>
        </div>
        <div class="ratio">
          正解率 <span class="ratio-num">{{ correctPercent }}</span
          ><span class="ratio-percent">%</span>
        </div>
      </div>
      <p class="footer-link">
        <template v-if="resultType == 'best'">
          <router-link
            class="base-button"
            to="/certificate"
            v-on:click.native="tapSound()"
            >認定証を表示</router-link
          >
          <br />
        </template>
        <router-link to="/" v-on:click.native="backToTop()"
          >クイズトップにもどる</router-link
        >
      </p>
    </div>
    <Copyright />
  </div>
</template>

<script>
import QuizModel from '../scripts/QuizModel';
import * as common from '../scripts/common'

export default {
  name: 'Answer',
  data() {
    const percent = QuizModel.getCorrectPercent();
    let type = 'default';
    if (percent >= 80) {
      type = 'best';
    } else if (percent >= 60) {
      type = 'good';
    }
    return {
      resultType: type,
      totalCount: QuizModel.getTotalCount(),
      correctCount: QuizModel.getCorrectCount(),
      correctPercent: percent,
    }
  },
  methods: {
    backToTop() {
      common.resetAnimation(this.$refs.animationContainer);
    }
  },
  mounted: function () {
    switch (this.resultType) {
      case 'best':
        common.setAnimation(this.$refs.animationContainer, 'public/images/anim/answerrate_80.gif')
        this.playSound('result_high');
        break;
      case 'good':
        common.setAnimation(this.$refs.animationContainer, 'public/images/anim/answerrate_60-70.gif')
        this.playSound('result_mid');
        break;
      case 'default':
      default:
        common.setAnimation(this.$refs.animationContainer, 'public/images/anim/answerrate_50.gif')
        this.playSound('result_low');
        break;
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

.result-box {
  position: relative;
  background-color: #fff;
  padding: 1em;
  border-radius: 1em;
  font-size: 17px;
  margin-top: 15px;
  margin-bottom: 10px;
  .heading {
    font-size: 17px;
  }
  .text {
    color: #e60000;
    margin-left: 1em;
  }
}

.result-box:after {
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  pointer-events: none;
  position: absolute;
  border-color: rgba(247, 221, 51, 0);
  border-top-width: 14px;
  border-bottom-width: 14px;
  border-left-width: 9px;
  border-right-width: 9px;
  border-bottom-color: #fff;
  bottom: 100%;
  left: 75%;
}

.score {
  font-size: 20px;
  text-align: center;
  border-bottom: #aae9c2 solid 2px;
  .score-num {
    font-size: 35px;
    color: $color-answer;
  }
  .score-correctness {
    font-size: 30px;
    color: $color-accent;
  }
}

.ratio {
  font-size: 20px;
  text-align: center;
  margin-bottom: -0.25em;
  .ratio-num {
    font-size: 60px;
    color: $color-accent;
    line-height: 1.2em;
    vertical-align: -4px;
  }
  .ratio-percent {
    font-size: 25px;
    margin-left: 0.2em;
  }
}

.footer-link {
  text-align: center;
  .base-button {
    margin-bottom: 1em;
  }
}
</style>
